<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert variant="danger" :show="data === undefined">
      <h4 class="alert-heading">
        Ошибка получения данных
      </h4>
      <div class="alert-body">
        Не удалось найти обьект с данным id. Проверьте
        <b-link
          class="alert-link"
          :to="{ name: 'railway_structure-fencing-list'}"
        >
          Список обьектов
        </b-link>
        список обьектов.
      </div>
    </b-alert>

    <template v-if="data">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <fencing-info-card :fencing-data="data" @open-tab="goTab" />

        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <user-responsability-info-card :data="data.user"/>
        </b-col>
        <b-col cols="12" class="mb-1">
          <b-button variant="outline-primary" :disabled="sheetLoading" @click="openSheet">
            <feather-icon icon="FileTextIcon" class="mr-50" />
            {{ sheetLoading ? 'Готовим ведомость…' : 'Ведомость промера' }}
          </b-button>
          <small class="text-muted ml-1">форма п. 7.7, лист А4</small>
        </b-col>
        <b-col>
          <b-tabs v-model="activeTab">
            <b-tab title="Замеры" lazy>
              <measurements-list :object-active-option="data.number"></measurements-list>
            </b-tab>

          </b-tabs>
        </b-col>
      </b-row>
    </template>

  </div>
</template>

<script>
import axios from '@axios'
  import store from '@/store'
  import router from '@/router'
  import {ref, onBeforeMount, onBeforeUnmount, onMounted} from '@vue/composition-api'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../fencingStoreModule'

  import {
    BCard, BCardBody, BCardTitle, BCardSubTitle, BTable, BRow, BCol, BAlert, BLink, BTabs, BTab, BButton
  } from 'bootstrap-vue'

  import useFencing from '../useFencing'

  import FencingInfoCard from '../components/FencingInfoCard.vue'
  import UserResponsabilityInfoCard from '@/views/apps/user/components/UserResponsabilityInfoCard.vue'
  import MeasurementsList from '@/views/apps/measurement/measurement/views/List.vue'


export default {
  data() {
    return {
      sheetLoading: false,
    }
  },
  methods: {
    /**
     * Ведомость промера габарита торцевого ограждения.
     *
     * Открывается новой вкладкой из памяти браузера: обращение требует ключа
     * доступа, а класть ключ в адрес нельзя — он остаётся в журнале сервера
     * и в истории браузера.
     */
    async openSheet() {
      this.sheetLoading = true
      try {
        const response = await axios.get(`/reports/fence/${this.data.id}/`, {
          responseType: 'blob',
        })
        const url = URL.createObjectURL(response.data)
        const sheet = window.open(url, '_blank')
        if (!sheet) {
          this.$bvToast.toast('Браузер заблокировал новое окно — разрешите всплывающие окна', {
            title: 'Ведомость не открылась', variant: 'warning', solid: true,
          })
        }
        setTimeout(() => URL.revokeObjectURL(url), 60000)
      } catch (error) {
        this.$bvToast.toast('Не удалось получить ведомость: ' + (error.message || 'нет ответа сервера'), {
          title: 'Ведомость промера', variant: 'danger', solid: true,
        })
      } finally {
        this.sheetLoading = false
      }
    },
  },

  components: {
    BButton,

    BCard,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    BTable,
    BRow,
    BCol,
    BAlert,
    BLink,
    BTabs,
    BTab,

    // Local Components
    FencingInfoCard,
    UserResponsabilityInfoCard,
    MeasurementsList

  },

  setup() {

      const data = ref(null)

      // Счётчики в карточке кликабельны: открывают вкладку со связанными объектами,
      // чтобы из любой сущности можно было перейти к её составу и обратно.
      const activeTab = ref(0)
      const tabKeys = ['measurement']
      const goTab = key => {
        const index = tabKeys.indexOf(key)
        if (index >= 0) activeTab.value = index
      }

      const { fetchDataUrl } = useFencing()

      // Re-register module with additional options
      onBeforeMount(() => {

        if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, STORE_MODULE_CONFIG)
      })

        // UnRegister on leave
      onBeforeUnmount(() => {
          if (!store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
      })

      onMounted( async ()=>{
        await store.dispatch(fetchDataUrl, { id: router.currentRoute.params.id })
                .then(response => { data.value = response.data })
                .catch((err) => {})
      })

      return {
        data,
        activeTab,
        goTab,
      }
    },
}
</script>
